import {useEffect} from 'react';
import * as _ from 'lodash';
import {serverLog} from '../../common/utils';

export function useServerLog(props) {
    const {type, title, errorMessage,  serverMsg, errorCode, httpStatusCode, refId, tenantId, id, auth, logPrefix} = props;
    useEffect( () => {
        if (!_.isEmpty(serverMsg)) {
            try {
                const  logPx = _.isNil(logPrefix) ? '' : logPrefix;
                const errorLog = {
                    type: _.isNil(type) ? '' : type,
                    title: _.isNil(title) ? '' : title,
                    errorMessage:  _.isNil(serverMsg) ? '' : serverMsg,
                    errorCode: _.isNil(errorCode) ?  '' : errorCode,
                    errorHttpCode: _.isNil(httpStatusCode) ? '' : httpStatusCode,
                    referentId: _.isNil(refId) ? '' : refId,
                    tenantId: _.isNil(tenantId) ? '' : tenantId,
                    pageId: _.isNil(id) ? '' : id,
                };

                window.CIG_LOG.debug('CigHeader: ErrorPage - Server: ', errorLog.errorMessage);
                const error = {
                    category: 'ERROR',
                    logMessage: logPx + ' ' + JSON.stringify(errorLog),
                };
                serverLog(auth, error);
            } 
            catch (e) {
                // do nothing
            }
        }
    },[ type, title, errorMessage, serverMsg, errorCode, httpStatusCode, refId, tenantId, id, logPrefix, auth]);
}